<template>
  
  <layout name="LoginLayout">
  
    <div class="text-center">
      
      <p>Página no encontrada.</p>

      <router-link :to="{'name': 'home'}">
      
        <v-btn 
          text
          color="primary"    >
        Volver
        </v-btn>
      
      </router-link>
      
    </div>
  
  </layout>

</template>

<script>

import Layout from '@/components/layouts/Layout.vue';

export default {
  name: 'NotFound',
  components: {
    Layout
  }
}

</script>